export function LoadingState() {
  return (
    <div className="loading-state">
      <div className="loading-scramble" aria-label="Recherche en cours" />
      <p className="loading-subtext">Analyse des conventions collectives</p>
    </div>
  );
}
